import * as React from 'react';

import { Switch, Route, useRouteMatch, useLocation } from 'react-router-dom';

import styled from 'styled-components';

import { Translate } from 'react-localize-redux';

import RegistrationStartPage from './registration-start';
import RegistrationVerifyPage from './registration-verify';

import Typography from '@components/basics/typography';
import FormContainer from '@components/layout/form-container';
import MotionOpacity from '@components/motion/motion-opacity';

interface RegistrationProps {
  className?: string;
}


export const Registration: React.FC<RegistrationProps> = (props) => {
  const location = useLocation();
  const match = useRouteMatch<{ account: string }>();
  const query = new URLSearchParams(useLocation().search);

  const [hasInfo, setHasInfo] = React.useState(true);
  const [contact, setContact] = React.useState('');


  const getTitle = () => {
    if (location.pathname.startsWith(`${match.path}/verify`)) {
      return <Translate id="AUTH.VERIFY.TITLE" />;
    }
    if (hasInfo) {
      return <Translate id="REGISTER.TITLE" />;
    }
    return <Translate id="REGISTER.TITLE.ALMOST" />;
  };

  return (
    <MotionOpacity>
      <FormContainer className={props.className}>
        <Title type="subheader" customFont="semi-bold">
          {getTitle()}
        </Title>
        <Switch>
          <Route
            exact
            path={match.path}
            render={() => (
              <RegistrationStartPage
                hasInfo={hasInfo}
                setHasInfo={setHasInfo}
                setContactValue={setContact}
              />
            )}
          />
          <Route
            exact
            path={`${match.path}/verify`}
            render={() => (
              <RegistrationVerifyPage
                account={query.get('account')}
                contact={contact}
              />
            )}
          />
        </Switch>
      </FormContainer>
    </MotionOpacity>
  );
};

export default (styled(Registration)`
  padding-top: 24px;

  @media ${({ theme }) => theme.device.tablet} {
    padding-top: 80px;
  }

  .back-icon {
    margin-bottom: 20px;

    @media ${({ theme }) => theme.device.tablet} {
      position: absolute;
      top: 70px;
      left: 32px;
      margin: 0;
      width: 50px;
      height: 50px;
    }
    @media ${({ theme }) => theme.device.tablet} {
      left: 0;
    }
  }
`);

const Title = styled(Typography)`
  margin-bottom: 20px;
`;
